/** @format */

import Cookie from 'js-cookie';
import { get, isArray, map, find, findIndex } from 'lodash';
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter, NavLink } from 'react-router-dom';
import { clearAllCookie } from 'utils/store';
import { Layout, Menu, Icon, Input, message } from 'antd';
import config from 'config/Config';
import { YxInput, YxAction, YxText } from 'yx-widget';
import CubeI8N from 'utils/cubeI8N';
// 路由资源地址
import { routerList } from 'router/index';

const { Sider } = Layout;
const { SubMenu } = Menu;
const Search = Input.Search;
const IconFont = YxText.Icon;

import styles from './SiderBarLess.less';
//自定义滚动条（解决ie、firefox自带滚动条难看的问题）
import { Scrollbars } from 'widget/ScrollBar/index';
// 异步请求
import cx from 'classnames';
import request from 'utils/request';

// 存储整棵菜单树的数据
let storeMenuList = [];
// 一级菜单的key值
let rootSubmenuKeys = [];
/**
 * @description: 替换菜单搜索关键词
 * @param {string} name 菜单名
 * @param {string} searchValue 搜索词
 * @return:
 */
const renderSearch = (name, searchValue) => {
  const template = `<span class="keyword">${searchValue}</span>`;
  if (searchValue && searchValue != '') {
    return name.replace(`${searchValue}`, template);
  } else {
    return name;
  }
};
// 递归渲染菜单项
const renderMenuItem = (menuArray, searchValue) => {
  // 遍历菜单列表
  return menuArray.map(item => {
    const name = config.languageEnv == 'enUS' ? item.name_i1 || item.name : item.name;
    if (item.children) {
      return (
        <SubMenu
          key={item.key}
          title={
            <span>
              <IconFont type={item.icon} iconfont={true} />
              <span
                dangerouslySetInnerHTML={{
                  __html: renderSearch(name, searchValue)
                }}
              />
            </span>
          }
        >
          {renderMenuItem(item.children, searchValue)}
        </SubMenu>
      );
    }
    return (
      <Menu.Item key={item.key}>
        <NavLink to={item.routePath ? item.routePath : '#'}>
          <IconFont type={item.icon} iconfont={true} />
          <span
            dangerouslySetInnerHTML={{
              __html: renderSearch(name, searchValue)
            }}
          />
        </NavLink>
      </Menu.Item>
    );
  });
};

@inject('AppStore', 'SiderBarMod')
@withRouter
class SiderBarView extends Component {
  constructor(props) {
    super(props);
    const current = localStorage.getItem('_openKey') || '';
    const localOpenKeys = localStorage.getItem('_openKeys');
    const openKeys = localOpenKeys ? JSON.parse(localOpenKeys) : [''];
    this.state = {
      // openKeys: [],
      // current: '',
      // 默认打开菜单
      openKeys,
      // 默认选中菜单的key
      current,
      // 菜单列表
      menuList: [],
      orgId: '',
      searchValue: ''
    };
    this.store = this.props.SiderBarMod;
  }

  flattenDepth = (menuList, deep = 1) => {
    let result = [];
    for (let menu of menuList) {
      let keys = [];
      const { children, key } = menu;
      keys.push(key);
      if (children instanceof Array) {
        keys.push(...this.flattenDepth(children, deep + 1));
      }
      result.push(keys);
    }

    return result;
  };
  async componentWillMount() {
    this.CubeI8N = new CubeI8N();
  }

  /**
   * 菜单点击处理
   * @param  {Object} e 事件源对象
   * @return {empty}   无
   */
  handleClick = e => {
    this.setState({
      current: e.key
    });
    const array = this.flattenDepth(this.state.menuList);
    localStorage.setItem('_openKey', get(e, 'key', ''));
  };

  setLocalStore = _openKeys => {
    if (_openKeys instanceof Array && _openKeys.length != 0 && this.state.current != '') {
      localStorage.setItem('_openKeys', JSON.stringify(_openKeys));
    }
  };

  handleOpen = openKeys => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
      this.setLocalStore(openKeys);
    } else {
      const keys = latestOpenKey ? [latestOpenKey] : [];
      this.setState({
        openKeys: keys
      });
      this.setLocalStore(keys);
    }
  };

  // 设置一级菜单目录的keys
  setRootKeys() {
    if (0 === this.state.menuList.length) {
      return false;
    }
    this.state.menuList.map((m, i) => {
      rootSubmenuKeys.push(m.key);
    });
  }

  // 对菜单进行搜索筛选
  filterMenu = value => {
    let filterArr = storeMenuList.filter(item => JSON.stringify(item).indexOf(value) >= 0);
    this.setState({
      menuList: filterArr,
      searchValue: value
    });
  };

  componentWillReceiveProps(props) {
    if (this.state.orgId + '' !== props.orgId + '') {
      this.setState({ orgId: props.orgId });
      this.getMenuList({ 'yes-req-org-id': props.orgId });
    }
  }

  getMenuList = data => {
    this.store.getMenuList(data || {}).then(res => {
      let roleSet = get(res, 'data.roleSet') || [];
      if (!roleSet.length) {
        this.props.history.closePageTabs('', this.props.history.location.pathname);
        this.props.history.push('/withoutPermission');
        return;
      } else if (
        find(roleSet, role => role.code === 'APPMANAGER') &&
        !find(roleSet, role => role.code === 'BOCMANAGER')
      ) {
        message.error('权限已修改，请重新登陆')
        clearAllCookie()
        this.props.history.push('/login');
        return;
      }

      let menuList = get(res, 'data.menus') || [];
      // 设置一级菜单的keys
      this.setState(
        {
          menuList
        },
        () => {
          // self.setOpenKeys();
          const access = [];
          const routerList = [];
          menuLists(menuList);
          function menuLists(arr) {
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].children && arr[i].children.length > 0) {
                menuLists(arr[i].children);
              } else {
                if (arr[i].routePath) {
                  access.push(arr[i].routePath);
                  routerList.push({
                    path: arr[i].routePath,
                    title: config.languageEnv == 'enUS' ? (arr[i].name_i1 || arr[i].name) : arr[i].name
                  });
                }
                delete arr[i].children;
              }
            }
          }
          routerList.push({
            path:'/withoutPermission',
            title: '无权限'
          })
          access.push('/withoutPermission')
          if (this.props.history.location.pathname == '/') {
            this.props.history.push(routerList[0].path);
          }
          this.props.AppStore.setRouterCfg(routerList);
          this.props.changeHasMenu({flag: true, menuList: access});
          let openKeys = this.state.openKeys;
          this.setState({
            openKeys
          });
          storeMenuList = menuList;
        }
      );
    });
  };
  componentDidMount() {
    this.getMenuList();
  }

  get searchParam() {
    return {
      isControlled: true,
      placeholder: this.CubeI8N.getString('basic.code-005'),
      className: 'siderBarInput',
      inputParam: {
        suffix: <IconFont type='iconiconsousuo' iconfont={true} />
      },
      value: this.state.searchValue,
      change: e => this.filterMenu(get(e, 'target.value', '')),
      styleParam: {
        width: 'xs', //宽度  xxs,xs,sm,md,lg,xl
        type: 'dark' //类型 default dark
      }
    };
  }

  render() {
    const { searchValue, openKeys, current } = this.state;
    const collapsed = this.props.collapsed;
    // inlineIndent 菜单层级左侧空格大小，单位为px，空格量=左侧空格大小*层级level
    return (
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className={`${styles.siderMain} ${collapsed ? styles.siderMainCollapsed : ''}`}
      >
        <div className={styles.menuWrap}>
          <div className={styles.menuCont}>
            {/*自定义滚动条组件*/}
            <Scrollbars
              className={styles.scrollbars}
              ref={e => {
                this.scrollbar = e;
              }}
              renderTrackVertical={props => <div {...props} className={styles.trackVertical} />}
              renderThumbVertical={props => <div {...props} className={styles.thumbVertical} />}
            >
              <div className={styles.searchBlock + ' yx_YxDynamicFormNoneGrid siderBarInput'}>
                <YxInput.Search {...this.searchParam} />
              </div>
              {/* 左侧菜单列表 */}
              <Menu
                theme='dark'
                mode='inline'
                selectedKeys={[current]}
                forceSubMenuRender={true}
                defaultOpenKeys={openKeys}
                onClick={this.handleClick}
                onOpenChange={this.handleOpen}
                // overflowedIndicator={
                //   <IconFont type={`iconiconriqijiantou`}></IconFont>
                // }
                defaultSelectedKeys={[current]}
              >
                {0 !== this.state.menuList.length && renderMenuItem(this.state.menuList, searchValue)}
              </Menu>
            </Scrollbars>
          </div>
          <div className={styles.siderFooter}>
            <YxAction
              className='trigger'
              type={collapsed ? 'iconiconzhankai' : 'iconiconshouqi'}
              styleType='icon'
              onClick={e => this.props.toggle(e)}
              iconfont={true}
            />
          </div>
        </div>
      </Sider>
    );
  }
}

export default SiderBarView;



// WEBPACK FOOTER //
// ./src/widget/SiderBar/SiderBarView.js